document.addEventListener('DOMContentLoaded', function () {
  textOpen()
  bigSliderOpen()
  newsOpen()
})
